interface AiSuggestedQuestionsProps {
  label?: string;
  questions: string[];
  onQuestionSelected: (question: string) => void;
}

export const AiSuggestedQuestions = ({
  label,
  questions,
  onQuestionSelected,
}: AiSuggestedQuestionsProps) => (
  <div className="tcw-suggested-questions">
    {questions.map((question, index) => (
      <button
        key={index}
        className="tmm-btn"
        onClick={() => onQuestionSelected(question)}
      >
        <span className="svg-icon svg-ai"></span>
        <span className="tmm-btn-text">{question}</span>
      </button>
    ))}
  </div>
);
